import { useState, useEffect, useRef } from "react";
import { useInView } from "framer-motion";
import { playKey } from "@/lib/sound";

export const Typewriter = ({
  words = [],
  typingSpeed = 105,
  deleteSpeed = 45,
  pause = 1600,
  className = "",
  cursorClassName = "text-[#BACD1C]",
}) => {
  const ref = useRef(null);
  const inView = useInView(ref);
  const [text, setText] = useState("");
  const [idx, setIdx] = useState(0);
  const [deleting, setDeleting] = useState(false);

  useEffect(() => {
    if (!inView || words.length === 0) return;
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      setText(words[0]);
      return;
    }
    const current = words[idx % words.length];
    let delay;
    if (!deleting && text === current) {
      delay = pause;
      const t = setTimeout(() => setDeleting(true), delay);
      return () => clearTimeout(t);
    }
    if (deleting && text === "") {
      setDeleting(false);
      setIdx((i) => (i + 1) % words.length);
      return;
    }
    delay = deleting ? deleteSpeed : typingSpeed;
    const t = setTimeout(() => {
      setText((prev) => {
        if (!deleting) {
          const nextChar = current[prev.length];
          if (nextChar && nextChar !== " ") playKey();
        }
        return deleting ? current.slice(0, prev.length - 1) : current.slice(0, prev.length + 1);
      });
    }, delay);
    return () => clearTimeout(t);
  }, [text, deleting, idx, inView, words, typingSpeed, deleteSpeed, pause]);

  return (
    <span ref={ref} className={className}>
      {text}
      <span className={`${cursorClassName} animate-blink`}>▋</span>
    </span>
  );
};
